// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"17416":"f5fb8f475a","54286":"72f1dca2da","60891":"8317c890fc","66586":"92e3fc3c1b"}[chunkId] + ".css";
};